
/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcceptQuoteResource,
  DeclineQuoteRequest,
  DeclinedQuoteResource,
  PreAcceptQuoteRequest,
  PurchaseOrderParam,
  QuoteManagerUpdateRequest,
  QuoteResource,
  SendQuoteToErpResponse,
  UpdateQuoteAppendixRequest,
} from '../models';
import {
    AcceptQuoteResourceFromJSON,
    AcceptQuoteResourceToJSON,
    DeclineQuoteRequestFromJSON,
    DeclineQuoteRequestToJSON,
    DeclinedQuoteResourceFromJSON,
    DeclinedQuoteResourceToJSON,
    PreAcceptQuoteRequestFromJSON,
    PreAcceptQuoteRequestToJSON,
    PurchaseOrderParamFromJSON,
    PurchaseOrderParamToJSON,
    QuoteManagerUpdateRequestFromJSON,
    QuoteManagerUpdateRequestToJSON,
    QuoteResourceFromJSON,
    QuoteResourceToJSON,
    SendQuoteToErpResponseFromJSON,
    SendQuoteToErpResponseToJSON,
    UpdateQuoteAppendixRequestFromJSON,
    UpdateQuoteAppendixRequestToJSON,
} from '../models';

export interface AcceptQuoteRequest {
    quoteId: string;
}

export interface DeclineQuoteOperationRequest {
    quoteId: string;
    declineQuoteRequest: DeclineQuoteRequest;
}

export interface DeleteQuoteAppendixRequest {
    quoteId: string;
}

export interface GetQuoteRequest {
    quoteId: string;
}

export interface GetQuoteByCorrelationIdRequest {
    correlationId: string;
}

export interface PreAcceptQuoteOperationRequest {
    quoteId: string;
    preAcceptQuoteRequest: PreAcceptQuoteRequest;
}

export interface SendQuoteToErpRequest {
    quoteId: string;
}

export interface SetPurchaseOrderToQuoteRequest {
    quoteId: string;
    purchaseOrderParam: PurchaseOrderParam;
}

export interface UpdateQuoteAppendixOperationRequest {
    quoteId: string;
    updateQuoteAppendixRequest: UpdateQuoteAppendixRequest;
}

export interface UpdateQuoteManagerRequest {
    quoteId: string;
    quoteManagerUpdateRequest: QuoteManagerUpdateRequest;
}

/**
 * 
 */
export class ProjectClientQuoteApi extends runtime.BaseAPI {

    /**
     * Accept a quote
          */
    async acceptQuoteRaw(requestParameters: AcceptQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AcceptQuoteResource>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling acceptQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AcceptQuoteResource>({
            path: `/project-client/api/quote/{quoteId}/accept`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AcceptQuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Accept a quote
          */
    async acceptQuote(requestParameters: AcceptQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AcceptQuoteResource> {
        const response = await this.acceptQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Decline a quote
          */
    async declineQuoteRaw(requestParameters: DeclineQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<DeclinedQuoteResource>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling declineQuote().'
            );
        }

        if (requestParameters['declineQuoteRequest'] == null) {
            throw new runtime.RequiredError(
                'declineQuoteRequest',
                'Required parameter "declineQuoteRequest" was null or undefined when calling declineQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<DeclinedQuoteResource>({
            path: `/project-client/api/quote/{quoteId}/decline`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeclineQuoteRequestToJSON(requestParameters['declineQuoteRequest']),
        }, initOverrides);

        if (response._data) { response._data=DeclinedQuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Decline a quote
          */
    async declineQuote(requestParameters: DeclineQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<DeclinedQuoteResource> {
        const response = await this.declineQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete the client quote appendix
          */
    async deleteQuoteAppendixRaw(requestParameters: DeleteQuoteAppendixRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling deleteQuoteAppendix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/project-client/api/quote/{quoteId}/appendix`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Delete the client quote appendix
          */
    async deleteQuoteAppendix(requestParameters: DeleteQuoteAppendixRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuoteAppendixRaw(requestParameters, initOverrides);
    }

    /**
     * Get a quote
          */
    async getQuoteRaw(requestParameters: GetQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteResource>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling getQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<QuoteResource>({
            path: `/project-client/api/quote/{quoteId}`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=QuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a quote
          */
    async getQuote(requestParameters: GetQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteResource> {
        const response = await this.getQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get a quote by correlation id
          */
    async getQuoteByCorrelationIdRaw(requestParameters: GetQuoteByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getQuoteByCorrelationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlationId'] = requestParameters['correlationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<QuoteResource>({
            path: `/project-client/api/quote`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=QuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a quote by correlation id
          */
    async getQuoteByCorrelationId(requestParameters: GetQuoteByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteResource> {
        const response = await this.getQuoteByCorrelationIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Pre accept a quote
          */
    async preAcceptQuoteRaw(requestParameters: PreAcceptQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling preAcceptQuote().'
            );
        }

        if (requestParameters['preAcceptQuoteRequest'] == null) {
            throw new runtime.RequiredError(
                'preAcceptQuoteRequest',
                'Required parameter "preAcceptQuoteRequest" was null or undefined when calling preAcceptQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/quote/{quoteId}/pre-accept`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreAcceptQuoteRequestToJSON(requestParameters['preAcceptQuoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Pre accept a quote
          */
    async preAcceptQuote(requestParameters: PreAcceptQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.preAcceptQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Send a quote to ERP (via Punchout)
          */
    async sendQuoteToErpRaw(requestParameters: SendQuoteToErpRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SendQuoteToErpResponse>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling sendQuoteToErp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SendQuoteToErpResponse>({
            path: `/project-client/api/quote/{quoteId}/sendToErp`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SendQuoteToErpResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Send a quote to ERP (via Punchout)
          */
    async sendQuoteToErp(requestParameters: SendQuoteToErpRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SendQuoteToErpResponse> {
        const response = await this.sendQuoteToErpRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the Purchase Order
          */
    async setPurchaseOrderToQuoteRaw(requestParameters: SetPurchaseOrderToQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling setPurchaseOrderToQuote().'
            );
        }

        if (requestParameters['purchaseOrderParam'] == null) {
            throw new runtime.RequiredError(
                'purchaseOrderParam',
                'Required parameter "purchaseOrderParam" was null or undefined when calling setPurchaseOrderToQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/quote/{quoteId}/purchase-order`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PurchaseOrderParamToJSON(requestParameters['purchaseOrderParam']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the Purchase Order
          */
    async setPurchaseOrderToQuote(requestParameters: SetPurchaseOrderToQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.setPurchaseOrderToQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Update the client quote appendix
          */
    async updateQuoteAppendixRaw(requestParameters: UpdateQuoteAppendixOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling updateQuoteAppendix().'
            );
        }

        if (requestParameters['updateQuoteAppendixRequest'] == null) {
            throw new runtime.RequiredError(
                'updateQuoteAppendixRequest',
                'Required parameter "updateQuoteAppendixRequest" was null or undefined when calling updateQuoteAppendix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/quote/{quoteId}/appendix`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuoteAppendixRequestToJSON(requestParameters['updateQuoteAppendixRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the client quote appendix
          */
    async updateQuoteAppendix(requestParameters: UpdateQuoteAppendixOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateQuoteAppendixRaw(requestParameters, initOverrides);
    }

    /**
     * Update the quote manager
          */
    async updateQuoteManagerRaw(requestParameters: UpdateQuoteManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['quoteId'] == null) {
            throw new runtime.RequiredError(
                'quoteId',
                'Required parameter "quoteId" was null or undefined when calling updateQuoteManager().'
            );
        }

        if (requestParameters['quoteManagerUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'quoteManagerUpdateRequest',
                'Required parameter "quoteManagerUpdateRequest" was null or undefined when calling updateQuoteManager().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-client/api/quote/{quoteId}/manager`.replace(`{${"quoteId"}}`, encodeURIComponent(String(requestParameters['quoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteManagerUpdateRequestToJSON(requestParameters['quoteManagerUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the quote manager
          */
    async updateQuoteManager(requestParameters: UpdateQuoteManagerRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateQuoteManagerRaw(requestParameters, initOverrides);
    }

}
